module.exports = __webpack_public_path__ + "img/download-img.e7235ebe.jpg";